<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('specification.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('specification.pageTitle'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">{{
            $t('add_new')
          }}</ts-button>
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
							v-tooltip="$t('specification.search')"
              style="width: 250px"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <Table
        :data="resources" 
        :columns="columns" 
        size="small"
        highlight-row
        stripe
        max-height="700"
        :loading="loading"
      >
          <template slot-scope="{ row }" slot="saleCode">
            {{ row.sale_code.sale_code }}
          </template>
          <template slot-scope="{ row }" slot="productNameEn">
            <td class="kh-font" style="border-bottom: none;">{{ row.sale_code.product.product_name_en }}</td>
          </template>
          <template slot-scope="{ row }" slot="uomNameEn">
            {{ row.sale_code.unit_of_measure.uom_name_en }}
          </template>
          <template slot-scope="{ row }" slot="specification">
            <td v-html="row.specification" style="border-bottom: none; padding: 4px 0;"></td>
          </template>
          <template slot-scope="{ row }" slot="action">
            <a
              href="#"
              v-tooltip="'Edit'"
              class="mr-2 text-primary"
              @click.prevent="edit(row)"
            >
              <i class="fas fa-edit"></i>
            </a>
          </template>
      </Table>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
    <a-modal
      v-if="show_form"
      v-model="show_form"
      :title="isUpdate ? $t('update') : $t('create')"
      :footer="null"
      :zIndex="1020"
    >
      <FormComponent @cancel="onCancel" />
    </a-modal>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormComponent from './form'

export default {
  name: 'productSpecification',
  components: {
    FormComponent,
  },
  data() {
    return {
      loading: false,
			show_form: false
    }
  },
  computed: {
    ...mapState('product/specification', ['resources', 'pagination']),
		isUpdate(){
			return !_.isEmpty(this.$store.state.product.specification.edit_data)
		},
    search: {
      get() {
        return this.$store.state.product.specification.search
      },
      set(newValue) {
        this.$store.commit('product/specification/SET_SEARCH', newValue)
        this.$store.commit('product/specification/RESET_CURRENT_PAGE')
      },
    },
    columns() {
      return [
        { title: this.$t('specification.saleCode'), 
          slot: 'saleCode'
        },
        { title: this.$t('specification.productName'), 
          slot: 'productNameEn'
        },
        { title: this.$t('specification.uom'), 
          slot: 'uomNameEn'
        },
        { title: this.$t('specification.content'), 
          slot: 'specification'
        },
        {
					title: this.$t('actions'),
					key: 'action',
					slot: 'action',
					fixed: 'right',
					align: 'center',
					width: 94
				}
      ]
    },
  },
  methods: {
    addNew() {
      this.show_form = true
    },
    onCancel() {
			this.show_form = false
			this.$store.commit('product/specification/SET_EDIT_DATA', {})
			this.fetchData()
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('product/specification/fetch', attributes)
        .then((response) => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('product/specification/SET_EDIT_DATA', record)
      this.show_form = true
    },
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500),
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('product/specification/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>